import { Routes } from '@angular/router';
import { AccountDataResolve } from '../account-data/account-data.resolve';
import { AuthGuard } from '../auth-data/auth.guard';
import { MobileGuard } from '../browser-manager-data/mobile.guard';
import { FeaturesDataResolve } from '../features-data/features-data.resolve';
import { CompletedOnboardingGuard } from '../onboarding-data/guards/completed-onboarding.guard';
import { AppDataGuard, RedirectGuard } from './guards';
import { MainComponent } from './containers';
import {
  ACCOUNT_BLOCKED_ROUTE,
  APPOINTMENTS_ROUTE,
  BILLING_ROUTE,
  CLIENTS_ROUTE,
  CREDIT_MEMOS_ROUTE,
  ESTIMATES_ROUTE,
  EXPENSES_ROUTE,
  HELP_ROUTE,
  HOME_MASTER_ROUTE,
  HOME_ROUTE,
  INSTANT_WEBSITE_ROUTE,
  INVOICES_ROUTE,
  ITEMS_ROUTE,
  ONBOARDING_ROUTE,
  PAYWALL_ROUTE,
  PURCHASE_ORDERS_ROUTE,
  REFER_A_FRIEND_ROUTE,
  REPORTS_ROUTE,
  SETTINGS_ROUTE,
  TRACKED_TIMES_ROUTE,
} from './main.data';
import { AccountBlockedComponent } from '../verify-account/components/account-blocked/account-blocked.component';
import { AccountBlockedGuard } from '../verify-account/account-blocked.guard';

export const featuresAccountDataResolve = {
  accountData: AccountDataResolve.RESOLVE.accountData,
  featuresData: FeaturesDataResolve.RESOLVE.featuresData,
};

export const routes: Routes = [
  {
    path: BILLING_ROUTE,
    loadChildren: () =>
      import('../billing/billing.module').then((m) => m.BillingModule),
    data: { preload: true },
  },
  {
    path: 'redirect',
    canActivate: [RedirectGuard],
    component: MainComponent, // here as a placeholder
    resolve: featuresAccountDataResolve,
  },
  {
    path: '',
    redirectTo: HOME_MASTER_ROUTE,
    pathMatch: 'full',
  },
  {
    path: ACCOUNT_BLOCKED_ROUTE,
    component: AccountBlockedComponent,
    resolve: featuresAccountDataResolve,
    canActivate: [AccountBlockedGuard],
  },
  {
    path: '',
    component: MainComponent,
    resolve: featuresAccountDataResolve,
    canActivate: [
      MobileGuard,
      AuthGuard,
      AppDataGuard,
      CompletedOnboardingGuard,
    ],
    canActivateChild: [AccountBlockedGuard],
    children: [
      {
        path: HOME_ROUTE,
        loadChildren: () =>
          import('../home/home.module').then((m) => m.HomeModule),
        data: { preload: true },
      },
      {
        path: INVOICES_ROUTE,
        loadChildren: () =>
          import('../invoices/invoices.module').then((m) => m.InvoicesModule),
        data: { preload: true },
      },
      {
        path: ESTIMATES_ROUTE,
        loadChildren: () =>
          import('../estimates/estimates.module').then(
            (m) => m.EstimatesModule
          ),
        data: { preload: true },
      },
      {
        path: PURCHASE_ORDERS_ROUTE,
        loadChildren: () =>
          import('../purchase-orders/purchase-orders.module').then(
            (m) => m.PurchaseOrdersModule
          ),
        data: { preload: true },
      },
      {
        path: CREDIT_MEMOS_ROUTE,
        loadChildren: () =>
          import('../credit-memos/credit-memos.module').then(
            (m) => m.CreditMemosModule
          ),
        data: { preload: true },
      },
      {
        path: CLIENTS_ROUTE,
        loadChildren: () =>
          import('../clients/clients.module').then((m) => m.ClientsModule),
        data: { preload: true },
      },
      {
        path: ITEMS_ROUTE,
        loadChildren: () =>
          import('../items/items.module').then((m) => m.ItemsModule),
        data: { preload: true },
      },
      {
        path: EXPENSES_ROUTE,
        loadChildren: () =>
          import('../expenses/expenses.module').then((m) => m.ExpensesModule),
        data: { preload: true },
      },
      {
        path: APPOINTMENTS_ROUTE,
        loadChildren: () =>
          import('../appointments/appointments.module').then(
            (m) => m.AppointmentsModule
          ),
        data: { preload: true },
      },
      {
        path: TRACKED_TIMES_ROUTE,
        loadChildren: () =>
          import('../tracked-times/tracked-times.module').then(
            (m) => m.TrackedTimesModule
          ),
        data: { preload: true },
      },
      {
        path: REPORTS_ROUTE,
        loadChildren: () =>
          import('../reports/reports.module').then((m) => m.ReportsModule),
        data: { preload: true },
      },
      {
        path: INSTANT_WEBSITE_ROUTE,
        loadChildren: () =>
          import('../instant-website/instant-website.module').then(
            (m) => m.InstantWebsiteModule
          ),
        data: { preload: true },
      },
      {
        path: REFER_A_FRIEND_ROUTE,
        loadChildren: () =>
          import('../refer-a-friend/refer-a-friend.module').then(
            (m) => m.ReferAFriendModule
          ),
        data: { preload: true },
      },
      {
        path: SETTINGS_ROUTE,
        loadChildren: () =>
          import('../settings/settings.module').then((m) => m.SettingsModule),
        data: { preload: true, hideSideNavigationIa: true },
      },
      {
        path: HELP_ROUTE,
        loadChildren: () =>
          import('../help-support/help-support.module').then(
            (m) => m.HelpSupportModule
          ),
        data: { preload: true },
      },
      {
        path: ONBOARDING_ROUTE,
        loadChildren: () =>
          import('../onboarding/onboarding.module').then(
            (m) => m.OnboardingModule
          ),
        data: {
          showSideNavigation: false,
        },
      },
      {
        path: PAYWALL_ROUTE,
        loadChildren: () =>
          import('../paywall/paywall.module').then((m) => m.PaywallModule),
        data: {
          preload: true,
          showSideNavigation: false,
        },
      },
    ],
  },
];
